import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Add, ArrowBack, CloseOutlined } from "@mui/icons-material";
import FaqSection from "./Faqsection";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./metatagseo.css";
import { useLocation } from "react-router-dom";

import MetaTagListItems from "./common/MetatagsListItems";
import {
  create_Page_category,
  getSingle_Page_category,
  update_Page_category,
} from "../auth/service";
import { toast, ToastContainer } from "react-toastify";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import plugins from "suneditor/src/plugins"; // 👈 import plugins
import { useMemo } from "react";
import OgTagListItems from "./common/OgTagsListItems";
import SchemaListItems from "./common/SchemaList";

// Removed quill-better-table imports

const AddApplicationCategory = () => {
  const [isModal, setModal] = useState(false);
  const [serviceModal, setServiceModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [serviceEditIndex, setServiceEditIndex] = useState(null);
  const [ogTagsModal, setOgTagsModal] = useState(false);
  const [serviceOgTagsModal, setServiceOgTagsModal] = useState(false);

  const [seoList, setSeoList] = useState([]);

  const [activeSection, setActiveSection] = useState("showroom");

  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [canonicalError, setCanonicalError] = useState("");
  const [ogList, setOgList] = useState([]);
  const [ogEditIndex, setOgEditIndex] = useState(null);
  const [showMetaFields, setShowMetaFields] = useState(false);
  const [faqList, setFaqList] = useState([]);
  const [ogFormData, setOgFormData] = useState({
    ogTitle: "",
    description: "",
    site_name: "",
    ogUrl: "",
    ogType: "website",
    ogLocale: "",
    ogImage: null,

    // ✅ Twitter
    twitterCard: "",
    twitterSite: "",
    twitterCreator: "",
    twitterTitle: "",
    twitterDescription: "",
    twitterImage: "",
  });

  const [formData, setFormData] = useState({
    metaTitle: "",
    metaDescription: "",
    seoContent: "",
    canonicalUrl: "",
  });

  const [schemaModal, setSchemaModal] = useState(false);
  const [serviceSchemaModal, setServiceSchemaModal] = useState(false);
  const [schemaList, setSchemaList] = useState([]);
  const [schemaEditIndex, setSchemaEditIndex] = useState(null);
  const [serviceSchemaEditIndex, setServiceSchemaEditIndex] = useState(null);

  const [schemaFormData, setSchemaFormData] = useState({
    schemaJson: "",
  });

  //Service center data states

  // ✅ SERVICE CENTER STATES
  const [serviceCategoryName, setServiceCategoryName] = useState("");

  const [serviceSeoList, setServiceSeoList] = useState([]);
  const [serviceFormData, setServiceFormData] = useState({
    metaTitle: "",
    metaDescription: "",
    seoContent: "",
    canonicalUrl: "",
  });

  const [serviceOgList, setServiceOgList] = useState([]);
  const [serviceOgFormData, setServiceOgFormData] = useState({
    ogTitle: "",
    description: "",
    site_name: "",
    ogUrl: "",
    ogType: "website",
    ogLocale: "",
    ogImage: null,

    twitterCard: "",
    twitterSite: "",
    twitterCreator: "",
    twitterTitle: "",
    twitterDescription: "",
    twitterImage: "",
  });

  const [serviceSchemaList, setServiceSchemaList] = useState([]);
  const [serviceSchemaFormData, setServiceSchemaFormData] = useState({
    schemaJson: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const categoryId = location.state?.id;

  useEffect(() => {
    if (!categoryId) return;

    (async () => {
      try {
        const data = await getSingle_Page_category(categoryId);
        const cat = data?.data;

        setCategoryName(cat.category || "");

        // SEO
        const seoData = {
          metaTitle: cat.title || "",
          metaDescription: cat.description || "",
          canonicalUrl: cat.canonical_url || "",
          seoContent: cat.page_content || "",
        };
        if (cat?.faqs && Array.isArray(cat.faqs)) {
          setFaqList(cat.faqs);
        }
        setSeoList([seoData]);
        setFormData(seoData);

        // OG Tags
        if (cat?.og_tags) {
          setOgList([
            {
              ogTitle: cat?.og_tags.title || "",
              description: cat?.og_tags?.description || "",
              site_name: cat?.og_tags?.site_name || "",
              ogUrl: cat?.og_tags?.url || "",
              ogType: cat?.og_tags?.type || "",
              ogLocale: cat?.og_tags?.locale || "",
              ogImage: cat?.og_tags?.image || "",

              // ✅ Twitter comes from twitter_tags
              twitterCard: cat?.twitter_tags?.card || "",
              twitterSite: cat?.twitter_tags?.site || "",
              twitterCreator: cat?.twitter_tags?.creator || "",
              twitterTitle: cat?.twitter_tags?.title || "",
              twitterDescription: cat?.twitter_tags?.description || "",
              twitterImage: cat?.twitter_tags?.image || "",
            },
          ]);
        }

        // Schema
        if (cat?.schema && Object.keys(cat.schema).length) {
          setSchemaList([
            {
              schemaJson: JSON.stringify(cat.schema, null, 2),
            },
          ]);
        }

        // Service Center SEO
        if (cat?.service_center?.seo) {
          const serviceSeoData = {
            metaTitle: cat.service_center.seo.title || "",
            metaDescription: cat.service_center.seo.description || "",
            canonicalUrl: cat.service_center.seo.canonical_url || "",
            seoContent: cat.service_center.seo.page_content || "",
          };
          setServiceSeoList([serviceSeoData]);
          setServiceFormData(serviceSeoData);
        }

        // Service Center OG Tags
        if (cat?.service_center?.og_tags) {
          setServiceOgList([
            {
              ogTitle: cat?.service_center?.og_tags.title || "",
              description: cat?.service_center?.og_tags?.description || "",
              site_name: cat?.service_center?.og_tags?.site_name || "",
              ogUrl: cat?.service_center?.og_tags?.url || "",
              ogType: cat?.service_center?.og_tags?.type || "",
              ogLocale: cat?.service_center?.og_tags?.locale || "",
              ogImage: cat?.service_center?.og_tags?.image || "",

              twitterCard: cat?.service_center?.twitter_tags?.card || "",
              twitterSite: cat?.service_center?.twitter_tags?.site || "",
              twitterCreator: cat?.service_center?.twitter_tags?.creator || "",
              twitterTitle: cat?.service_center?.twitter_tags?.title || "",
              twitterDescription:
                cat?.service_center?.twitter_tags?.description || "",
              twitterImage: cat?.service_center?.twitter_tags?.image || "",
            },
          ]);
        }

        // Service Center Schema
        if (
          cat?.service_center?.schema &&
          Object.keys(cat.service_center.schema).length
        ) {
          setServiceSchemaList([
            {
              schemaJson: JSON.stringify(cat.service_center.schema, null, 2),
            },
          ]);
        }
      } catch (err) {
        console.error(err);
      }
    })();
  }, [categoryId]);

  const handleNavigate = () => {
    navigate("/dashboard/category/category-list-application");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    setServiceFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, seoContent: value }));
  };

  const handleServiceQuillChange = (value) => {
    setServiceFormData((prev) => ({ ...prev, seoContent: value }));
  };

  const handleEdit = (index) => {
    setFormData(seoList[index]);
    setEditIndex(index);
    setModal(true);
  };

  const handleServiceEdit = (index) => {
    setServiceFormData(serviceSeoList[index]);
    setServiceEditIndex(index);
    setServiceModal(true);
  };

  const handleSave = () => {
    const { metaTitle, metaDescription, seoContent, canonicalUrl } = formData;

    // if (!metaTitle || !metaDescription || !canonicalUrl) {
    //   alert("Please fill all fields before saving");
    //   return;
    // }

    if (editIndex !== null) {
      const updatedList = [...seoList];
      updatedList[editIndex] = formData;
      setSeoList(updatedList);
      setEditIndex(null);
    } else {
      setSeoList((prev) => [...prev, formData]);
    }

    setFormData({
      metaTitle: "",
      metaDescription: "",
      canonicalUrl: "",
      seoContent: "",
    });
    setModal(false);
  };

  const handleServiceSave = () => {
    const { metaTitle, metaDescription, seoContent, canonicalUrl } =
      serviceFormData;

    if (serviceEditIndex !== null) {
      const updatedList = [...serviceSeoList];
      updatedList[serviceEditIndex] = serviceFormData;
      setServiceSeoList(updatedList);
      setServiceEditIndex(null);
    } else {
      setServiceSeoList((prev) => [...prev, serviceFormData]);
    }

    setServiceFormData({
      metaTitle: "",
      metaDescription: "",
      canonicalUrl: "",
      seoContent: "",
    });
    setServiceModal(false);
  };

  const handleSavePageCategory = async (id) => {
    if (!categoryName) {
      alert("Please enter category name");
      return;
    }

    if (seoList.length === 0) {
      alert("Please add at least one Meta Tag and SEO Content");
      return;
    }

    const seoItem = seoList[0];
    const ogItem = ogList.length ? ogList[0] : null;

    const og_tags = ogItem
      ? {
        title: ogItem.ogTitle,
        description: ogItem.description,
        site_name: ogItem.site_name,
        url: ogItem.ogUrl,

        locale: ogItem.ogLocale,
        image: ogItem.ogImage || "",

        type: "website", //ogItem.ogType,
      }
      : null;

    const twitter_tags = ogItem
      ? {
        card: ogItem.twitterCard || "",
        site: ogItem.twitterSite || "",
        creator: ogItem.twitterCreator || "",
        title: ogItem.twitterTitle || "",
        description: ogItem.twitterDescription || "",
        image: ogItem.twitterImage || "",
      }
      : null;

    const schema =
      schemaList.length && schemaList[0]?.schemaJson
        ? JSON.parse(schemaList[0].schemaJson)
        : {};

    // Service Center Data
    const serviceSeoItem = serviceSeoList.length ? serviceSeoList[0] : null;
    const serviceOgItem = serviceOgList.length ? serviceOgList[0] : null;

    const service_og_tags = serviceOgItem
      ? {
        title: serviceOgItem.ogTitle,
        description: serviceOgItem.description,
        site_name: serviceOgItem.site_name,
        url: serviceOgItem.ogUrl,
        locale: serviceOgItem.ogLocale,
        image: serviceOgItem.ogImage || "",
        type: "website",
      }
      : null;

    const service_twitter_tags = serviceOgItem
      ? {
        card: serviceOgItem.twitterCard || "",
        site: serviceOgItem.twitterSite || "",
        creator: serviceOgItem.twitterCreator || "",
        title: serviceOgItem.twitterTitle || "",
        description: serviceOgItem.twitterDescription || "",
        image: serviceOgItem.twitterImage || "",
      }
      : null;

    const service_schema =
      serviceSchemaList.length && serviceSchemaList[0]?.schemaJson
        ? JSON.parse(serviceSchemaList[0].schemaJson)
        : {};

    const payload = {
      title: seoItem.metaTitle,
      description: seoItem.metaDescription,
      canonical_url: seoItem.canonicalUrl,
      category: categoryName,
      page_content: seoItem.seoContent,

      og_tags: og_tags, // ✅ correct format
      schema: schema, // ✅ object (not string)
      twitter_tags: twitter_tags,

      // Service Center Data - grouped in one object
      service_center: {
        seo: serviceSeoItem
          ? {
            title: serviceSeoItem.metaTitle,
            description: serviceSeoItem.metaDescription,
            canonical_url: serviceSeoItem.canonicalUrl,
            page_content: serviceSeoItem.seoContent,
          }
          : null,
        og_tags: service_og_tags,
        schema: service_schema,
        twitter_tags: service_twitter_tags,
      },

      active: true,
      faqs: faqList.map((item, idx) => ({
        id: idx + 1,
        metaTitle: item.metaTitle || "",
        metaDescription: item.metaDescription || "",
        slug: item.slug || "",
        question: item.question || "",
        answer: item.answer || "",
      }))
    };

    try {
      if (categoryId) {
        const data = await update_Page_category(payload, id);
        if (!data.error) {
          toast.dismiss();

          toast.success(
            data?.message || "Page category updated successfully!",
            { toastId: "category-success" },
          );
          setCategoryName("");
          setSeoList([]);
          setServiceSeoList([]);
          setServiceOgList([]);
          setServiceSchemaList([]);
          setFaqList([]);
          setTimeout(() => {
            navigate("/dashboard/category/category-list-application");
          }, 800);
        } else {
          toast.error(data?.message || "Failed to update category");
        }
      } else {
        const data = await create_Page_category(payload);
        if (!data.error) {
          toast.success(data?.message || "Page category created successfully!");
          console.log(data?.message);
          setCategoryName("");
          setSeoList([]);
          setServiceSeoList([]);
          setServiceOgList([]);
          setServiceSchemaList([]);
          toast.dismiss();

          setTimeout(() => {
            navigate("/dashboard/category/category-list-application");
          }, 800);
        } else {
          toast.dismiss();

          toast.error(data?.message || "Failed to create category", {
            toastId: "category-error",
          });
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong");
    }
  };

  const editorOptions = useMemo(
    () => ({
      plugins,
      buttonList: [
        ["undo", "redo"],
        ["formatBlock"],
        ["font", "fontSize"],
        ["bold", "italic", "underline", "strike"],
        ["fontColor", "hiliteColor"],
        ["align", "list", "lineHeight"],
        ["link", "image", "video", "table"],
        ["fullScreen", "showBlocks", "template"],
        ["removeFormat"],
      ],
      removeFormatTags: [
        "b",
        "strong",
        "span",
        "font",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
      ],
      removeFormatAttributes: ["style", "class"],
      templates: [
        {
          name: "50% Text + 50% Image",
          html: `
        <div class="row-50-50">
          <div class="col text">
            <p>✍ Write your text here...</p>
          </div>
          <div class="col image">
            <img src="" alt="image" />
          </div>
        </div>
      `,
        },
      ],
    }),
    [],
  );

  const handleSaveOgTags = () => {
    // check if user entered at least ONE value
    const hasAnyValue = Object.values(ogFormData).some(
      (value) => value && value.trim && value.trim() !== "",
    );

    // ❌ if nothing entered, just close modal (don’t save)
    if (!hasAnyValue) {
      setOgTagsModal(false);
      return;
    }

    if (ogEditIndex !== null) {
      const updated = [...ogList];
      updated[ogEditIndex] = ogFormData;
      setOgList(updated);
      setOgEditIndex(null);
    } else {
      setOgList([ogFormData]); // only one OG allowed
    }

    setOgFormData({
      ogTitle: "",
      description: "",
      site_name: "",
      ogUrl: "",
      ogType: "",
      ogLocale: "",
      ogImage: null,

      twitterCard: "",
      twitterSite: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: "",
    });

    setOgTagsModal(false);
  };

  const handleSaveServiceOgTags = () => {
    // check if user entered at least ONE value
    const hasAnyValue = Object.values(serviceOgFormData).some(
      (value) => value && value.trim && value.trim() !== "",
    );

    // ❌ if nothing entered, just close modal (don't save)
    if (!hasAnyValue) {
      setServiceOgTagsModal(false);
      return;
    }

    if (ogEditIndex !== null) {
      const updated = [...serviceOgList];
      updated[ogEditIndex] = serviceOgFormData;
      setServiceOgList(updated);
      setOgEditIndex(null);
    } else {
      setServiceOgList([serviceOgFormData]); // only one OG allowed
    }

    setServiceOgFormData({
      ogTitle: "",
      description: "",
      site_name: "",
      ogUrl: "",
      ogType: "",
      ogLocale: "",
      ogImage: null,

      twitterCard: "",
      twitterSite: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: "",
    });

    setServiceOgTagsModal(false);
  };

  const handleSaveSchema = () => {
    try {
      JSON.parse(schemaFormData.schemaJson);
    } catch (err) {
      alert("Invalid JSON schema. Please fix it.");
      return;
    }

    if (schemaEditIndex !== null) {
      const updated = [...schemaList];
      updated[schemaEditIndex] = schemaFormData;
      setSchemaList(updated);
      setSchemaEditIndex(null);
    } else {
      setSchemaList((prev) => [...prev, schemaFormData]);
    }

    setSchemaFormData({ schemaJson: "" });
    setSchemaModal(false);
  };

  const handleSaveServiceSchema = () => {
    try {
      JSON.parse(serviceSchemaFormData.schemaJson);
    } catch (err) {
      alert("Invalid JSON schema. Please fix it.");
      return;
    }

    if (serviceSchemaEditIndex !== null) {
      const updated = [...serviceSchemaList];
      updated[serviceSchemaEditIndex] = serviceSchemaFormData;
      setServiceSchemaList(updated);
      setServiceSchemaEditIndex(null);
    } else {
      setServiceSchemaList((prev) => [...prev, serviceSchemaFormData]);
    }

    setServiceSchemaFormData({ schemaJson: "" });
    setServiceSchemaModal(false);
  };

  const handleDeleteSchema = (index) => {
    if (!window.confirm("Are you sure you want to delete this schema?")) return;

    setSchemaList([]); // only one schema allowed
    setSchemaEditIndex(null);
    setSchemaFormData({ schemaJson: "" });
  };

  return (
    <div className="category-add">
      <div className="category-header-container">
        <span className="metaTag-header">
          {categoryId
            ? "Edit Application Page Categories"
            : "Add Application Page Categories"}
        </span>

        <div className="btn-flex">
          <Button
            variant="contained"
            className="bordered-button"
            onClick={() => {
              handleSavePageCategory(categoryId);
            }}
          >
            {categoryId ? "UPDATE PAGE CATEGORY" : " SAVE PAGE CATEGORY"}
          </Button>
          <Button
            variant="outlined"
            className="bordered-button"
            startIcon={<ArrowBack />}
            onClick={handleNavigate}
          >
            BACK
          </Button>
        </div>
      </div>

      <div className="container">
        <label className="label">Page Category Name</label>

        <input
          type="text"
          className="input"
          name="category"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
        />
      </div>

      <div className="container">
        <label className="label">Page Meta tags and SEO Content</label>
        <Button
          onClick={() => {
            setActiveSection("showroom");
            setFormData({
              metaTitle: "",
              metaDescription: "",
              seoContent: "",
            });
            setEditIndex(null);
            setModal(true);
          }}
          variant="outlined"
          size="small"
          startIcon={<Add />}
          disabled={seoList.length > 0}
        >
          Meta tags and SEO Content
        </Button>
      </div>

      <div className="container">
        <div
          className="seo-list"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {seoList.map((item, index) => (
            <MetaTagListItems
              key={index}
              formData={item}
              onEdit={() => handleEdit(index)}
            />
          ))}
        </div>
      </div>

      <div className="container">
        <label className="label">Page OG Tags</label>
        <Button
          onClick={() => {
            setFormData({
              metaTitle: "",
              metaDescription: "",
              seoContent: "",
            });
            setEditIndex(null);
            setOgTagsModal(true);
          }}
          variant="outlined"
          size="small"
          startIcon={<Add />}
          disabled={ogList.length > 0} // ✅ disable once added
        >
          Add OG Tags
        </Button>
      </div>

      <div className="container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {ogList.map((item, index) => (
            <OgTagListItems
              key={index}
              formData={item}
              onEdit={() => {
                setOgFormData(item);
                setOgEditIndex(index);
                setOgTagsModal(true);
              }}
            />
          ))}
        </div>
      </div>

      {/* <div className="container">
        <label className="label">Page Schema</label>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Add />}
          disabled={schemaList.length > 0} // ✅ disable once added
          onClick={() => {
            setSchemaFormData({ schemaJson: "" });
            setSchemaEditIndex(null);
            setSchemaModal(true);
          }}
        >
          Add Page Schema
        </Button>
      </div> */}

      <div className="container">
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {schemaList.map((item, index) => (
            <SchemaListItems
              key={index}
              formData={item}
              onEdit={() => {
                setSchemaFormData(item);
                setSchemaEditIndex(index);
                setSchemaModal(true);
              }}
              onDelete={() => handleDeleteSchema(index)}
            />
          ))}
        </div>
      </div>

      <Dialog
        open={ogTagsModal}
        // onClose={() => setModal(false)}
        onClose={() => setOgTagsModal(false)} // ✅ FIXED
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          style: {
            height: "100vh",
            margin: 0,
          },
        }}
      >
        <DialogTitle>
          {editIndex !== null ? "Edit OG Tags" : "Add OG Tags"}

          <IconButton
            onClick={() => setOgTagsModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers style={{ maxHeight: "70vh" }}>
          <h2>Open Graph (Facebook)</h2>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:title</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:title"
              value={ogFormData.ogTitle}
              onChange={(e) =>
                setOgFormData((prev) => ({ ...prev, ogTitle: e.target.value }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:description</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:description"
              value={ogFormData.description}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:site_name</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:site_name"
              value={ogFormData.site_name}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  site_name: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:url</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:URL"
              value={ogFormData.ogUrl}
              onChange={(e) =>
                setOgFormData((prev) => ({ ...prev, ogUrl: e.target.value }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:type</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            {/* <input
              className="textField"
              type="text"
              placeholder="Enter og:Type"
              value={ogFormData.ogType}
              onChange={(e) =>
                setOgFormData((prev) => ({ ...prev, ogType: e.target.value }))
              }
            /> */}
            <input className="textField" type="text" value="website" disabled />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">Og:locale</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:Locale"
              value={ogFormData.ogLocale}
              onChange={(e) =>
                setOgFormData((prev) => ({ ...prev, ogLocale: e.target.value }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">og:image</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:image"
              value={ogFormData.ogImage}
              onChange={(e) =>
                setOgFormData((prev) => ({ ...prev, ogImage: e.target.value }))
              }
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <h2>Open Graph (Twitter)</h2>
          </div>

          <div className="form_comp">
            <label className="title">Twitter:card</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:card"
              value={ogFormData.twitterCard}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterCard: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:site</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:site"
              value={ogFormData.twitterSite}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterSite: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:creator</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:creator"
              value={ogFormData.twitterCreator}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterCreator: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:title</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:title"
              value={ogFormData.twitterTitle}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterTitle: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:description</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:description"
              value={ogFormData.twitterDescription}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterDescription: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:image</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:image"
              value={ogFormData.twitterImage}
              onChange={(e) =>
                setOgFormData((prev) => ({
                  ...prev,
                  twitterImage: e.target.value,
                }))
              }
            />
          </div>
        </DialogContent>
        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button
            className="quil-close-btn"
            variant="outlined"
            onClick={() => setOgTagsModal(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              // handleSave();
              handleSaveOgTags();
            }}
          >
            {ogEditIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={isModal}
        onClose={() => setModal(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          style: {
            height: "100vh",
            margin: 0,
          },
        }}
      >
        <DialogTitle>
          {editIndex !== null
            ? "Edit Meta Tags and SEO Content"
            : "Add Meta Tags and SEO Content"}

          <IconButton
            onClick={() => setModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ maxHeight: "70vh" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f9f9f9",
              padding: "10px 16px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              marginBottom: "16px",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <Button
              variant={showMetaFields ? "contained" : "outlined"}
              size="small"
              color="primary"
              onClick={() => setShowMetaFields((prev) => !prev)}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                borderRadius: "6px",
              }}
            >
              {showMetaFields ? "Hide Meta Fields" : "Show Meta Fields"}
            </Button>
            {/* <Typography
              variant="body2"
              sx={{
                color: "#1976d2",
                fontStyle: "italic",
                flex: 1,
                minWidth: "200px",
              }}
            >
              For cities, please add <strong>Meta Title</strong>,{" "}
              <strong>Meta Description</strong>, and <strong>Canonical</strong>{" "}
              in the Store Locations tab.
            </Typography> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                marginTop: "8px",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#1976d2", fontStyle: "italic" }}
              >
                For cities, please add <strong>Meta Title</strong>,{" "}
                <strong>Meta Description</strong>, and{" "}
                <strong>Canonical</strong> in the Store Locations tab.
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#555", fontStyle: "italic" }}
              >
                Note: For cities, only <strong>SEO Content</strong> will be
                displayed on the frontend.
              </Typography>
            </div>
          </div>

          {showMetaFields && (
            <>
              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Meta Title</label>
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Title"
                  value={formData.metaTitle}
                  onChange={handleChange}
                  name="metaTitle"
                />
              </div>
              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Meta Description</label>{" "}
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Description"
                  value={formData.metaDescription}
                  onChange={handleChange}
                  name="metaDescription"
                />
              </div>

              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Canonical URL</label>{" "}
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Canonical URL"
                  value={formData.canonicalUrl}
                  onChange={handleChange}
                  name="canonicalUrl"
                />
              </div>
            </>
          )}

          <div className="form_comp">
            <label className="title">SEO Content</label>
            <SunEditor
              // setContents={formData.seoContent}
              key={editIndex ?? "new"}
              defaultValue={formData.seoContent}
              onChange={(content) => {
                setFormData((prev) => ({ ...prev, seoContent: content }));
              }}
              height="300px"
              setOptions={editorOptions}
            />
          </div>
        </DialogContent>
        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button
            className="quil-close-btn"
            variant="outlined"
            onClick={() => setModal(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              handleSave();
            }}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>
      <Dialog
        open={schemaModal}
        onClose={() => setSchemaModal(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {schemaEditIndex !== null ? "Edit Page Schema" : "Add Page Schema"}
          <IconButton
            onClick={() => setSchemaModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            label="Schema Markup (JSON-LD)"
            multiline
            minRows={12}
            fullWidth
            value={schemaFormData.schemaJson}
            onChange={(e) => setSchemaFormData({ schemaJson: e.target.value })}
            placeholder="Paste valid JSON-LD schema here"
          />
        </DialogContent>

        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button variant="outlined" onClick={() => setSchemaModal(false)}>
            Close
          </Button>
          <Button variant="contained" onClick={handleSaveSchema}>
            {schemaEditIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>

      {/* Service Center SEO Modal */}
      <Dialog
        open={serviceModal}
        onClose={() => setServiceModal(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          style: {
            height: "100vh",
            margin: 0,
          },
        }}
      >
        <DialogTitle>
          {serviceEditIndex !== null
            ? "Edit Service Center Meta Tags and SEO Content"
            : "Add Service Center Meta Tags and SEO Content"}

          <IconButton
            onClick={() => setServiceModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ maxHeight: "70vh" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f9f9f9",
              padding: "10px 16px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              marginBottom: "16px",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <Button
              variant={showMetaFields ? "contained" : "outlined"}
              size="small"
              color="primary"
              onClick={() => setShowMetaFields((prev) => !prev)}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                borderRadius: "6px",
              }}
            >
              {showMetaFields ? "Hide Meta Fields" : "Show Meta Fields"}
            </Button>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                marginTop: "8px",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#1976d2", fontStyle: "italic" }}
              >
                For cities, please add <strong>Meta Title</strong>,{" "}
                <strong>Meta Description</strong>, and{" "}
                <strong>Canonical</strong> in the Store Locations tab.
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#555", fontStyle: "italic" }}
              >
                Note: For cities, only <strong>SEO Content</strong> will be
                displayed on the frontend.
              </Typography>
            </div>
          </div>

          {showMetaFields && (
            <>
              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Meta Title</label>
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Title"
                  value={serviceFormData.metaTitle}
                  onChange={handleServiceChange}
                  name="metaTitle"
                />
              </div>
              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Meta Description</label>{" "}
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Description"
                  value={serviceFormData.metaDescription}
                  onChange={handleServiceChange}
                  name="metaDescription"
                />
              </div>

              <div className="form_comp">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label className="title">Canonical URL</label>{" "}
                  <sup style={{ color: "red" }}>*</sup>
                </div>
                <input
                  className="textField"
                  type="text"
                  placeholder="Enter Canonical URL"
                  value={serviceFormData.canonicalUrl}
                  onChange={handleServiceChange}
                  name="canonicalUrl"
                />
              </div>
            </>
          )}

          <div className="form_comp">
            <label className="title">SEO Content</label>
            <SunEditor
              key={serviceEditIndex ?? "new-service"}
              defaultValue={serviceFormData.seoContent}
              onChange={(content) => {
                setServiceFormData((prev) => ({
                  ...prev,
                  seoContent: content,
                }));
              }}
              height="300px"
              setOptions={editorOptions}
            />
          </div>
        </DialogContent>
        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button
            className="quil-close-btn"
            variant="outlined"
            onClick={() => setServiceModal(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              handleServiceSave();
            }}
          >
            {serviceEditIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>

      {/* Service Center OG Modal */}
      <Dialog
        open={serviceOgTagsModal}
        onClose={() => setServiceOgTagsModal(false)}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          style: {
            height: "100vh",
            margin: 0,
          },
        }}
      >
        <DialogTitle>
          {ogEditIndex !== null
            ? "Edit Service Center OG Tags"
            : "Add Service Center OG Tags"}

          <IconButton
            onClick={() => setServiceOgTagsModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers style={{ maxHeight: "70vh" }}>
          <h2>Open Graph (Facebook)</h2>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:title</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:title"
              value={serviceOgFormData.ogTitle}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  ogTitle: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:description</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:description"
              value={serviceOgFormData.description}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:site_name</label>
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:site_name"
              value={serviceOgFormData.site_name}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  site_name: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:url</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:URL"
              value={serviceOgFormData.ogUrl}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  ogUrl: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">og:type</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input className="textField" type="text" value="website" disabled />
          </div>
          <div className="form_comp">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label className="title">Og:locale</label>{" "}
              <sup style={{ color: "red" }}>*</sup>
            </div>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:Locale"
              value={serviceOgFormData.ogLocale}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  ogLocale: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">og:image</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter og:image"
              value={serviceOgFormData.ogImage}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  ogImage: e.target.value,
                }))
              }
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <h2>Open Graph (Twitter)</h2>
          </div>

          <div className="form_comp">
            <label className="title">Twitter:card</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:card"
              value={serviceOgFormData.twitterCard}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterCard: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:site</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:site"
              value={serviceOgFormData.twitterSite}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterSite: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:creator</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:creator"
              value={serviceOgFormData.twitterCreator}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterCreator: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:title</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:title"
              value={serviceOgFormData.twitterTitle}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterTitle: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:description</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:description"
              value={serviceOgFormData.twitterDescription}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterDescription: e.target.value,
                }))
              }
            />
          </div>
          <div className="form_comp">
            <label className="title">Twitter:image</label>

            <input
              className="textField"
              type="text"
              placeholder="Enter twitter:image"
              value={serviceOgFormData.twitterImage}
              onChange={(e) =>
                setServiceOgFormData((prev) => ({
                  ...prev,
                  twitterImage: e.target.value,
                }))
              }
            />
          </div>
        </DialogContent>
        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button
            className="quil-close-btn"
            variant="outlined"
            onClick={() => setServiceOgTagsModal(false)}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              handleSaveServiceOgTags();
            }}
          >
            {ogEditIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>

      {/* Service Center Schema Modal */}
      <Dialog
        open={serviceSchemaModal}
        onClose={() => setServiceSchemaModal(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {serviceSchemaEditIndex !== null
            ? "Edit Service Center Schema"
            : "Add Service Center Schema"}
          <IconButton
            onClick={() => setServiceSchemaModal(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            label="Schema Markup (JSON-LD)"
            multiline
            minRows={12}
            fullWidth
            value={serviceSchemaFormData.schemaJson}
            onChange={(e) =>
              setServiceSchemaFormData({ schemaJson: e.target.value })
            }
            placeholder="Paste valid JSON-LD schema here"
          />
        </DialogContent>

        <div className="btn-group" style={{ paddingLeft: "24px" }}>
          <Button
            variant="outlined"
            onClick={() => setServiceSchemaModal(false)}
          >
            Close
          </Button>
          <Button variant="contained" onClick={handleSaveServiceSchema}>
            {serviceSchemaEditIndex !== null ? "Update" : "Add"}
          </Button>
        </div>
      </Dialog>

      {/* ================= SERVICE CENTER SECTION ================= */}

      <div
        className="container"
        style={{ fontSize: "24px", fontWeight: "bold" }}
      >
        Service Center Page Data
      </div>

      {/* SEO */}
      <div className="container">
        <label className="label">Service Center Meta tags & SEO</label>

        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => {
            setActiveSection("service");
            setServiceFormData({
              metaTitle: "",
              metaDescription: "",
              seoContent: "",
              canonicalUrl: "",
            });
            setServiceEditIndex(null);
            setServiceModal(true);
          }}
          disabled={serviceSeoList.length > 0}
        >
          Add Service Center SEO
        </Button>
      </div>

      <div className="container">
        {serviceSeoList.map((item, index) => (
          <MetaTagListItems
            key={index}
            formData={item}
            onEdit={() => {
              setActiveSection("service");
              setServiceFormData(item);
              setServiceEditIndex(index);
              setServiceModal(true);
            }}
          />
        ))}
      </div>

      {/* OG */}
      <div className="container">
        <label className="label">Service Center OG Tags</label>

        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => {
            setServiceOgFormData({
              ogTitle: "",
              description: "",
              site_name: "",
              ogUrl: "",
              ogType: "website",
              ogLocale: "",
              ogImage: null,

              twitterCard: "",
              twitterSite: "",
              twitterCreator: "",
              twitterTitle: "",
              twitterDescription: "",
              twitterImage: "",
            });
            setOgEditIndex(null);
            setServiceOgTagsModal(true);
          }}
          disabled={serviceOgList.length > 0}
        >
          Add Service Center OG
        </Button>
      </div>

      <div className="container">
        {serviceOgList.map((item, index) => (
          <OgTagListItems
            key={index}
            formData={item}
            onEdit={() => {
              setServiceOgFormData(item);
              setOgEditIndex(index);
              setServiceOgTagsModal(true);
            }}
          />
        ))}
      </div>

      {/* SCHEMA */}
      <div className="container">
        <label className="label">Service Center Schema</label>

        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => {
            setServiceSchemaFormData({ schemaJson: "" });
            setServiceSchemaEditIndex(null);
            setServiceSchemaModal(true);
          }}
          disabled={serviceSchemaList.length > 0}
        >
          Add Service Schema
        </Button>
      </div>

      <div className="container">
        {serviceSchemaList.map((item, index) => (
          <SchemaListItems
            key={index}
            formData={item}
            onEdit={() => {
              setServiceSchemaFormData(item);
              setServiceSchemaEditIndex(index);
              setServiceSchemaModal(true);
            }}
            onDelete={() => setServiceSchemaList([])}
          />
        ))}
      </div>
      <FaqSection faqList={faqList} setFaqList={setFaqList} />
    </div>
  );
};

export default AddApplicationCategory;
